import { Component, Input, OnInit, Output, EventEmitter  } from '@angular/core';
import { GridColumnDto } from '@hub/generated/models';

@Component({
  selector: 'g-columnFaIcon',
  templateUrl: './columnFaIcon.component.html',
  styles: [
    `
    span:hover {
      cursor: pointer;
    }
    `
  ]
})
export class ColumnFaIconComponent implements OnInit {
  constructor() { }

  @Input() data: any;
  @Input() icon: string;
  @Input() isEditing: boolean = false;
  @Output() onClick = new EventEmitter();


  ngOnInit() {
   
  }

  onIconClick(data) {
    this.onClick.emit(data);
  }
}
